import React from 'react';
export function MechanismSection() {
  return <section className="py-16 md:py-24 px-4 bg-navy text-white relative overflow-hidden" data-id="element-284">
      {/* Subtle background pattern/glow */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-bl from-navy-light to-transparent opacity-50 pointer-events-none" data-id="element-285"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-286">
        <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-287">
          <span className="inline-block border border-gold/30 bg-gold/10 text-gold font-bold tracking-widest text-xs md:text-sm uppercase px-4 py-1.5 rounded-full mb-6" data-id="element-288">
            LO QUE NADIE TE HA EXPLICADO
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight mb-6 text-balance" data-id="element-289">
            Un proceso invisible actúa dentro de ti cada vez que el azúcar
            permanece elevado en tu sangre.
          </h2>
          <p className="text-lg md:text-xl text-cream/80 font-sans font-light leading-relaxed" data-id="element-290">
            La ciencia lo estudia desde hace décadas. Se llama glicación. Tiene
            consecuencias documentadas en tus órganos vitales.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-291">
          {/* Card 1 */}
          <div className="bg-navy-light/50 border border-white/5 rounded-xl p-6 backdrop-blur-sm hover:bg-navy-light/80 transition-colors" data-id="element-292">
            <h3 className="text-xl font-serif font-bold text-gold mb-3 flex items-center gap-2" data-id="element-293">
              <span className="text-2xl" data-id="element-294">🫀</span> Corazón y arterias
            </h3>
            <p className="text-cream/70 font-sans leading-relaxed text-sm" data-id="element-295">
              Pérdida de elasticidad arterial documentada por la cardiología
              moderna.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-navy-light/50 border border-white/5 rounded-xl p-6 backdrop-blur-sm hover:bg-navy-light/80 transition-colors" data-id="element-296">
            <h3 className="text-xl font-serif font-bold text-gold mb-3 flex items-center gap-2" data-id="element-297">
              <span className="text-2xl" data-id="element-298">🧠</span> Cerebro y nervios
            </h3>
            <p className="text-cream/70 font-sans leading-relaxed text-sm" data-id="element-299">
              Células que no se renuevan — vulnerables a la acumulación
              silenciosa.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-navy-light/50 border border-white/5 rounded-xl p-6 backdrop-blur-sm hover:bg-navy-light/80 transition-colors" data-id="element-300">
            <h3 className="text-xl font-serif font-bold text-gold mb-3 flex items-center gap-2" data-id="element-301">
              <span className="text-2xl" data-id="element-302">👁</span> Ojos
            </h3>
            <p className="text-cream/70 font-sans leading-relaxed text-sm" data-id="element-303">
              El cristalino: uno de los tejidos más expuestos a este proceso.
            </p>
          </div>

          {/* Card 4 */}
          <div className="bg-navy-light/50 border border-white/5 rounded-xl p-6 backdrop-blur-sm hover:bg-navy-light/80 transition-colors" data-id="element-304">
            <h3 className="text-xl font-serif font-bold text-gold mb-3 flex items-center gap-2" data-id="element-305">
              <span className="text-2xl" data-id="element-306">🫘</span> Riñones
            </h3>
            <p className="text-cream/70 font-sans leading-relaxed text-sm" data-id="element-307">
              Capacidad de filtración afectada de forma gradual e invisible.
            </p>
          </div>
        </div>

        <div className="flex justify-center mb-12" data-id="element-308">
          <img src="https://cdn.magicpatterns.com/uploads/eYZ2oMbykAsymZyzKBT91X/Imagen_-_Mapa_del_dano_Silencioso.png" alt="Mapa del Daño Silencioso — Los órganos afectados por la glicación" className="w-full max-w-lg h-auto rounded-2xl shadow-lg" data-id="element-309" />
        </div>

        {/* Highlight Card */}
        <div className="max-w-3xl mx-auto bg-navy-dark border border-cta/40 rounded-xl p-8 text-center shadow-[0_0_30px_rgba(200,16,46,0.1)]" data-id="element-310">
          <p className="text-xl md:text-2xl font-serif italic text-white leading-relaxed" data-id="element-311">
            "No duele. No avisa. No enciende ninguna alarma visible. Por eso es
            silencioso. Por eso es tan relevante entenderlo."
          </p>
        </div>
      </div>
    </section>;
}